import { SmartConnectorStats } from './types';

export const defaultSmartConnectorStats: SmartConnectorStats = {
  used_count: 0,
};

export const FLOW_BAR_HEIGHT = 55;
export const FLOW_PADDING = 75;
